import Utils from '../../modules/utils'

const getPoeInfo = (callback) => {
  Utils.get('poe_info', (err, res) => {
    if (err) { return }
    callback(res.data || {})
  })
}

export {getPoeInfo}
